import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router';
import { RemittanceService } from 'app/modules/remittance/services/remittance.service';
import { ToastrService } from 'ngx-toastr';
import { OrderService } from '../../services/order.service';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { WsfxBankDetails } from 'app/shared/constant/wsfx-bank-details';
import { PaymentMode } from 'app/shared/constant/payment-mode';
import { Constants } from 'app/shared/constant/constants';

@Component({
  selector: 'retry-payment',
  templateUrl: './retry-payment.component.html',
  styleUrls: ['./retry-payment.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RetryPaymentComponent implements OnInit {

  public bankAccountList: any;
  public showLoader: boolean = false;
  public bankAccountId: any;

  public paymentMode: any;
  public orderID: any;
  public orderDetails: any;
  public paymentMethod: any;
  public isPartial : boolean ;
  public selectedPaymentMode: any;
  public accountName = WsfxBankDetails.ACCOUNT_NAME;
  public bankName = WsfxBankDetails.BANK_NAME;
  public accountNo = WsfxBankDetails.ACCOUNT_NUMBER;
  public bankIFSC = WsfxBankDetails.BANK_IFSC;
  public bankBranch = WsfxBankDetails.BANK_BRANCH;
  public showNEFT: boolean = true;
  public isPayPartial:boolean = false;
  public productEnum: any;

  public NBPaymentHtml: string = "";
  public NBPaymentInProcees: boolean = false;
  public paymentProcessInProgress: boolean = false;
  public xplorerOrderDetail: any;

  constructor(
    private router: Router,
    public remittanceService: RemittanceService,
    public toast: ToastrService,
    public orderService: OrderService,
    private route: ActivatedRoute,
  ) {
    this.orderID = this.route.snapshot.paramMap.get('orderID');
  }

  ngOnInit() {
    this.getOrderDetails();
    this.getBankAccountList();
    this.paymentMethod = false;
    this.isPartial = false;
  }

  getBankAccountList() {
    this.remittanceService.getBankAccountList().subscribe(resp => {
      this.bankAccountList = resp.body;
    }, error => {
    });
  }

  getOrderDetails() {
    this.showLoader = true;
    if (this.orderID && this.orderID.toString().toLowerCase().startsWith('x')) {
      this.getXplorerOrderDetails();
    } else {
      this.orderService.getOrderDetailsSingle(this.orderID).subscribe(resp => {
        this.showLoader = false;
        this.orderDetails = resp.body;
        if(this.orderDetails["productGroup"] == "FOREX" && (this.orderDetails["orderType"] == "BUY_CARD" || this.orderDetails["orderType"] == "RELOAD_CARD")) {
          this.productEnum = Constants.productsEnum[0];
        } else if(this.orderDetails["productGroup"] == "REMITTANCE") {
          this.productEnum = Constants.productsEnum[2];
        } else {
          this.productEnum = Constants.productsEnum[1];
        }

      }, error => {
        this.showLoader = false;
        this.toast.error(error.error.message);
      });
    }
  }

  getXplorerOrderDetails() {
    this.orderService.getXplorerOrderDetail(this.orderID).subscribe(resp => {
      this.showLoader = false;
      this.orderDetails = resp.body;
      this.xplorerOrderDetail = (resp.body as any)?.order;
      this.productEnum = Constants.productsEnum[0];
    }, error => {
      this.showLoader = false;
      this.toast.error(error.error.message);
    });
  }

  getSelectedPaymentType(isPartial) {
    this.isPayPartial =  isPartial;
    if(isPartial) {
      this.showNEFT = false;
    } else {
      this.showNEFT = true;
    }
    this.paymentMode = undefined;
    this.paymentMethod = isPartial;
  }

  getSelectedPaymentMode(paymentModeValue) {
    this.selectedPaymentMode = paymentModeValue;
    sessionStorage.setItem(ConstantsKey.PAYMENT_METHOD, paymentModeValue);
  }

  proceedToPayment() {
      if (this.bankAccountId) {
          console.log("PAYMENT METHOD ---------------------------------- ",this.paymentMethod);
        if (this.paymentMethod != undefined && this.paymentMethod != null && this.paymentMode != '') {
          if (this.paymentMode) {
            /* if (this.paymentMode == PaymentMode.NET_BANKING) {
              this.getPaymentGatewayLink(this.orderID);
            } else */ 
             if(this.paymentMode == PaymentMode.UPI || this.paymentMode == PaymentMode.NET_BANKING) {
              this.getUPIPaymentLink(this.orderID);
            } else {
              this.router.navigate(['/payment-success', this.orderID]);
            }
          } else {
            this.toast.error('Please select payment mode !');
          }
        } else {
          this.toast.error('Please select payment method! ');
        }
      } else {
        this.toast.error('Please select bank account ! ');
      }
  }

  getSelectedBankAccountID(id) {
    this.bankAccountId = id;
  }

  getPaymentGatewayLink(orderId: string) {
      this.showLoader = true;

    this.orderService.getRetryPaymentGatewayLinkOrders(orderId, this.bankAccountId).subscribe(respPaymentLink => {
      this.showLoader = false;
      var responsePaymentLinkBody = JSON.parse(JSON.stringify(respPaymentLink.body));
      window.location.href = responsePaymentLinkBody.payment_link;
      sessionStorage.setItem(ConstantsKey.IS_FROM_BUYNEWCARD, 'false');
      sessionStorage.setItem(ConstantsKey.IS_FROM_REMITTANCE_FLOW, 'false');
      sessionStorage.setItem(ConstantsKey.IS_FROM_RELOAD, 'false');
      sessionStorage.setItem(ConstantsKey.IS_FROM_RETRY_PAYMENT, 'true');      
      sessionStorage.setItem(ConstantsKey.PAYMENT_METHOD, 'NB');
    }, error => {
      this.showLoader = false;
      console.log("Error in generating payment link");
    });
  }

  getUPIPaymentLink(orderId: string) {
    this.showLoader = true;
    // this.getSessionData();
    let requestObj = {
      'paymentType': this.paymentMode,
      'orderId': orderId,
      'bankId': this.bankAccountId,
      'deviceType': 'WEB'
    };
    if(this.xplorerOrderDetail){
      requestObj['product']='XPLORER_CARD_KIT';
      requestObj['orderType']='XPLORER_CARD_KIT';

      this.orderService.getPayUOtherLink(requestObj).subscribe(resp => {
        this.handleUPIPaymentLinkResponse(resp, orderId);
      }, error => {
        this.showLoader = false;
        console.log("Error in generating payment link");
      });
      return;
    }else{
      requestObj['product']=this.productEnum;
    }

    this.orderService.getPayULink(orderId, requestObj, this.isPayPartial).subscribe(resp => {
      this.handleUPIPaymentLinkResponse(resp, orderId);
    }, error => {
      this.showLoader = false;
      console.log("Error in generating payment link");
    });
  }

  handleUPIPaymentLinkResponse(resp: any, orderId: string) {
    this.showLoader = false;
    sessionStorage.setItem(ConstantsKey.IS_FROM_BUYNEWCARD, 'false');
    sessionStorage.setItem(ConstantsKey.IS_FROM_REMITTANCE_FLOW, 'false');
    sessionStorage.setItem(ConstantsKey.IS_FROM_RELOAD, 'false');
    sessionStorage.setItem(ConstantsKey.IS_FROM_RETRY_PAYMENT, 'true');
    var respUPIPayLinkData = JSON.parse(JSON.stringify(resp.body));
    //window.location.href = respUPIPayLinkData.redirectionURL;

    //localStorage.setItem(ConstantsKey.IS_PERS_REMITTANCE_ORDER_DONE, "IN_PROCESS");
    if(respUPIPayLinkData.status == "SUCCESS") {
      if(respUPIPayLinkData.redirectionURL) {
        window.location.href = respUPIPayLinkData.redirectionURL;
      } else {
        this.NBPaymentHtml = respUPIPayLinkData.htmlCode;
        document.open();
        document.write(this.NBPaymentHtml);
        document.close();
      }
    } else if(respUPIPayLinkData.status == "ERROR") {
      let errMsg:string = respUPIPayLinkData.errorDescription;
      if(errMsg.includes("not support PayU")) {
        this.getPaymentGatewayLink(orderId);
      }
    }
  }

}